import React from 'react';
import { FormItem } from '..';
import PropTypes from 'prop-types';
import { InputGroup } from 'react-bootstrap';

const validations = ['matchType'];
class SimpleSelect extends FormItem {
  static propTypes = FormItem.extendPropTypes({
    options:     PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    className:   PropTypes.string
  });
  getOptions () {
    const self = this;
    return self.props.options;
  }
  constructor (props) {
    super(props);
    const self = this;
    self.defineValidations(validations);
    self.getTypes = self.getTypes.bind(self);
  }
  getTypes () {
    const self = this;
    return self.getOptions().reduce((map, option) => {
      if (typeof option === 'string') {
        map[option] = option;
        return map;
      }
      map[option.value] = option.text;
      return map;
    }, {});
  }
  renderReadonly () {
    const self = this;
    const value = String(self.getVal() || '');
    const text = !value ? '' : self.getOptions().filter((option) => {
      if (option === value) {
        return true;
      }
      if (option.value) {
        return option.value === value;
      }
      return option.text === value;
    })[0];
    return <p className="mb-0">{text || ''}</p>;
  }
  renderInput () {
    const self = this;
    const { placeholder, className } = self.props;
    const classes = className ? className.split(' ') : [];
    classes.push(self.getFormControlClassName());
    const options = self.getOptions().map((option, i) => {
      if (!option) {
        return <option value="" />;
      }
      if (typeof option === 'string') {
        return (
          <option key={`option-${i}`} value={option}>
            {option}
          </option>
        );
      }
      return (
        <option key={`option-${i}`} value={option.value || option.text} {...option.props || {}}>
          {option.text}
        </option>
      );
    });
    return (
      <div>
        <InputGroup>
          <select
            className={classes ? classes.join(' ') : ''}
            value={self.getVal() || ''}
            onChange={(event) => self.setVal(event.target.value)}
          >
            {placeholder && (
              <option value="" disabled className="d-none">
                {placeholder}
              </option>
            )}
            {options}
          </select>
        </InputGroup>
        {self.renderValError()}
      </div>
    );
  }
}
export default SimpleSelect;
